import React, { useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { jsonValue } from '../../types/jsonValue';
import { inputFormValueState, inputFormChangedState } from '../../stores/formState';
import { completedComponentState } from '../../stores/completedComponentState';

interface Option {
  label: string;
  value: jsonValue;
}

export interface CheckBoxesProps {
  componentId: string;
  options: Option[];
  optional: boolean;
}

const MultiSelect: React.FC<CheckBoxesProps> = props => {
  const [value, setValue] = useRecoilState(inputFormValueState(props.componentId));
  const setCompleted = useSetRecoilState(completedComponentState(props.componentId));
  const changed = useRecoilValue(inputFormChangedState(props.componentId));

  const values = value == null ? [] : value instanceof Array ? value : [value];
  const defaultValue = useMemo(() => {
    if (!props.optional) return [];
    if (props.options.find(o => o.value === '')) return [];
    return [''];
  }, [props.optional, props.options]);

  const toggleOptions = useMemo(() => {
    return props.options.reduce((ret, option) => {
      ret[String(option.value)] = () => {
        setValue(old => {
          const array = old == null ? [] : old instanceof Array ? old : [old];
          if (array.includes(option.value)) {
            const retVal = array.filter(v => v !== option.value);
            return retVal.length > 0 ? retVal : defaultValue;
          } else {
            return [...array, option.value];
          }
          // return array.includes(option.value) ? array.filter(v => v !== option.value) : [...array, option.value];
        });
        setCompleted(true)
      }
      return ret;
    }, {} as Record<string, () => void>);
  }, [props.options, setCompleted, setValue, defaultValue]);

  useEffect(() => {
    setValue(prev => prev ?? defaultValue);
  }, [defaultValue, setValue]);

  return (
    <div className={"multiselect" + (changed ? " changed" : "")}>
      <div className="multiselect-banner"><p className="multiselect-text">複数選択可</p></div>
      {props.options.map(option =>
        <button key={String(option.value)} className={values.includes(option.value) ? 'checked' : ''} type="button" onClick={toggleOptions[String(option.value)]}>{option.label}</button>
      )}
    </div>
  );
};

export default MultiSelect;
